import { render, staticRenderFns } from "./BookingItem.vue?vue&type=template&id=22e3804e&scoped=true&"
import script from "./BookingItem.vue?vue&type=script&lang=ts&"
export * from "./BookingItem.vue?vue&type=script&lang=ts&"
import style0 from "./BookingItem.vue?vue&type=style&index=0&id=22e3804e&lang=scss&scoped=true&"
import style1 from "./BookingItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e3804e",
  null
  
)

export default component.exports